import React from 'react';

import IconButton from '~components/_common/IconButton/IconButton';
import translate from '~src/i18n/translate';

// import theme from '../../../styles/theme';

// const style = {
//   container: {},
// };

const icon = (iconStyle, icons, customStyle, translation) => (
  <IconButton
    iconStyle={iconStyle}
    icon={icons}
    customStyle={customStyle}
    tooltip={translation ? translate(translation) : null}
    backgroundOff
  />
);

export default icon;
